import React from 'react';
import { Copy, Check } from '@phosphor-icons/react';
import { copyTextToClipboard } from './clipboard-copy';

type CopyValueButtonProps = {
  /** Value written to the clipboard. */
  value: string;
  /** Used only to build the `aria-label` (e.g. "Copy Organization ID"). */
  label: string;
};

/**
 * Small icon-only copy affordance shared by the org-detail rows (workspace
 * address, Organization ID): a transient check icon on click, no toast.
 */
export function CopyValueButton({ value, label }: CopyValueButtonProps) {
  const [copied, setCopied] = React.useState(false);
  return (
    <button
      type="button"
      onClick={async () => {
        const success = await copyTextToClipboard(value);
        if (success) {
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        }
      }}
      aria-label={`Copy ${label}`}
      className="p-1 rounded hover:bg-muted transition-colors text-muted-foreground hover:text-foreground"
    >
      {copied ? <Check size={12} className="text-success" /> : <Copy size={12} />}
    </button>
  );
}
